<template>
  <div>
    <el-dialog
      top="50px"
      :close-on-click-modal="false"
      v-loading="detailLoading"
      :title="isEdit ? '编辑' : '新建'"
      :visible.sync="show"
      width="80%"
      @close="onClear"
    >
      <el-form class="margin-top-10" label-width="130px" :rules="rules" ref="form" :model="form">
        <el-row>
          <el-col :span="12">
            <p class="title">
              <span class="margin-left-10" style="vertical-align: middle">基本信息</span>
            </p>
            <el-form-item label="活动名称" prop="name">
              <el-input
                :disabled="isEdit"
                clearable
                style="width: 415px"
                v-model.trim="form.name"
                placeholder="不超过10个字"
              />
            </el-form-item>
            <!-- <el-form-item label="隶属公司" prop="merchantIds">
              <YdMerchantSelector
                :disabled="isEdit"
                v-model="form.merchantIds"
                placeholder="请选择隶属公司"
                @change="onChange"
                styles="width: 415px"
              />
            </el-form-item>
            <el-form-item :show-message="!form.shiFouSuoYouXianLu" label="可用线路" prop="lineIds">
              <div class="flex-between">
                <el-select
                  v-show="!form.shiFouSuoYouXianLu"
                  filterable
                  multiple
                  :disabled="!form.merchantIds"
                  style="width: 350px"
                  placeholder="请选择可用线路"
                  v-model="form.lineIds"
                  clearable
                >
                  <el-option
                    v-for="item in lineList"
                    :label="item.lineName"
                    :value="item.id"
                    :key="item.id"
                  />
                </el-select>

                <el-checkbox
                  :true-label="1"
                  :false-label="0"
                  :disabled="!form.merchantIds"
                  @change="onAllChange"
                  v-model="form.shiFouSuoYouXianLu"
                  >全部</el-checkbox
                >
              </div>
            </el-form-item> -->
            <el-form-item label="隶属公司" prop="merchanList" class="is-required" v-if="!isEdit">
              <div>
                <el-button type="primary" size="mini" @click="handleMerchant">添加</el-button>
                <el-checkbox
                  class="margin-left-10"
                  :true-label="1"
                  :false-label="0"
                  @change="onAllChange"
                  v-model="form.shiFouSuoYouXianLu"
                >
                  全部
                </el-checkbox>
              </div>
              <div style="padding-left: 66px; box-sizing: border-box">
                <div
                  v-for="(item, index) in merchantList"
                  :key="item.merchantId"
                  class="margin-bottom-10"
                >
                  <div>
                    <i class="el-icon-remove-outline" @click="removeMerchan(index)"></i>
                    <span class="margin-left-10">{{ item.merchantName }}</span>
                  </div>
                  <div class="box-card" v-if="Array.isArray(item.line) && item.line.length > 0">
                    <el-checkbox
                      style="margin-left: 0"
                      v-for="(citem, index) in item.line"
                      :key="index"
                      :size="'mini'"
                      v-model="citem.check"
                      true-label="1"
                      false-label="2"
                      :border="true"
                    >
                      {{ citem.lineName }}
                    </el-checkbox>
                  </div>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="隶属公司" prop="merchantNames" v-if="isEdit">
              <span>{{ form.shiFouSuoYouXianLu === 1 ? '全部' : form.merchantNames }}</span>
            </el-form-item>
            <el-form-item label="可用线路" prop="lineNames" v-if="isEdit">
              <span>{{ form.shiFouSuoYouXianLu === 1 ? '全部' : form.lineNames }}</span>
            </el-form-item>

            <el-form-item label="可参与订单数" prop="huoDongCiShu">
              <el-input
                :disabled="isEdit"
                placeholder="请输入订单数"
                style="width: 415px"
                :max="999999"
                v-model.number="form.huoDongCiShu"
                :min="1"
                label="请输入整数"
              />
            </el-form-item>
            <el-form-item label="预算金额" prop="huoDongZongJinE">
              <el-input
                :disabled="isEdit"
                placeholder="请输入预算金额"
                style="width: 415px"
                v-model.number="form.huoDongZongJinE"
                :max="999999"
                :min="1"
              />
            </el-form-item>
            <el-form-item label="活动时间" prop="time">
              <el-date-picker
                style="width: 415px"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="pickerOptions"
                v-model="form.time"
                type="datetimerange"
                align="left"
                unlink-panels
                range-separator="至"
                :default-time="['00:00:00', '23:59:59']"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
              />
            </el-form-item>
            <el-form-item label="使用说明" prop="describe">
              <el-input
                style="width: 415px"
                type="textarea"
                :autosize="{ minRows: 6, maxRows: 8 }"
                placeholder="展示在乘客端，可用线路自动添加"
                v-model="form.describe"
                maxlength="500"
                show-word-limit
              />
              <!-- <div
                v-if="
                  (form.describe && form.lineIds.length > 0 && form.describe) ||
                  (form.shiFouSuoYouXianLu && form.describe)
                "
                class="flex-start text-eli"
              >
                <span class="color-redFont font-13 margin-right-5">活动线路无需填写，自动拼接</span>
                <el-button size="mini" @click="showRule" type="text">预览规则</el-button>
              </div> -->
              <div v-if="form.describe && lineStr" class="flex-start text-eli">
                <span class="color-redFont font-13 margin-right-5">活动线路无需填写，自动拼接</span>
                <el-button size="mini" @click="showRule" type="text">预览规则</el-button>
              </div>
            </el-form-item>

            <el-form-item label="使用条件" prop="withNewUser">
              <el-switch
                :active-value="1"
                :inactive-value="0"
                v-model="form.withNewUser"
                active-text="仅新用户可用"
                inactive-text=""
              />
            </el-form-item>
            <el-form-item label="与优惠券互斥" prop="withCoupon">
              <el-switch
                :disabled="true"
                :active-value="1"
                :inactive-value="0"
                v-model="form.withCoupon"
                active-text=""
                inactive-text=""
              />
              <span class="font-12 color-redFont margin-left-10"
                >开启表示下单立减活动不可与优惠券叠加使用</span
              >
            </el-form-item>
            <el-form-item label="是否可重复参与" prop="shiFouChongFu">
              <el-switch
                :active-value="1"
                :inactive-value="0"
                v-model="form.shiFouChongFu"
                active-text=""
                inactive-text=""
              />
              <span class="font-12 color-redFont margin-left-10">开启表示用户可多次参与活动</span>
            </el-form-item>
            <el-form-item label="扫码补票是否可用" prop="buPiaoShiFouKeYong">
              <el-switch
                :active-value="1"
                :inactive-value="0"
                v-model="form.buPiaoShiFouKeYong"
                active-text=""
                inactive-text=""
              />
              <span class="font-12 color-redFont margin-left-10"
                >开启表示扫描司机补票码可用该优惠</span
              >
            </el-form-item>

            <el-form-item label="是否关联渠道码" prop="enableChannelCode">
              <div>
                <el-switch
                  :active-value="1"
                  :inactive-value="0"
                  v-model="form.enableChannelCode"
                  active-text=""
                  inactive-text=""
                />
                <span class="font-12 color-redFont margin-left-10"
                  >开启表示仅通过扫描渠道码下单的用户可享受立减活动优惠</span
                >
              </div>
            </el-form-item>

            <el-form-item label="关联渠道码" prop="channelIdList" v-if="channelShow">
              <div class="position-relative">
                <el-select
                  v-model="form.channelIdList"
                  multiple
                  filterable
                  remote
                  reserve-keyword
                  placeholder="请输入关键词"
                  :loading="loading"
                  style="width: 415px"
                >
                  <el-popover
                    v-for="item in channelOptions"
                    :key="item.id"
                    width="200"
                    trigger="hover"
                    placement="right"
                  >
                    <div class="channel-dialog">
                      <div class="item">
                        <div class="font-weight">{{ item.name }}</div>
                      </div>
                      <div class="item">
                        <div class="tit">地址：</div>
                        <div class="txt">{{ item.address }}</div>
                      </div>
                      <div class="item">
                        <div class="tit">负责人：</div>
                        <div class="txt">{{ item.admin }}</div>
                      </div>
                      <div class="item">
                        <div class="tit">邮箱：</div>
                        <div class="txt">{{ item.email }}</div>
                      </div>
                      <div class="item">
                        <div class="tit">电话：</div>
                        <div>{{ item.phone }}</div>
                      </div>
                      <div class="item">
                        <div class="tit">备注：</div>
                        <div class="txt">{{ item.remark }}</div>
                      </div>
                      <div class="item">
                        <div class="flex-1">
                          <span class="tit">新用户首单：</span>
                          <span>{{ item.fristOrder / 100 }}%</span>
                        </div>
                        <div class="flex-1">
                          <span class="tit">常规订单：</span>
                          <span>{{ item.commondOrder / 100 }}%</span>
                        </div>
                      </div>
                    </div>
                    <el-option slot="reference" :label="item.name" :value="item.id" />
                  </el-popover>
                </el-select>
              </div>
            </el-form-item>

            <!--            <el-form-item label="活动规则" prop="activityRule" v-if="channelShow">-->
            <!--              <RichTextEditor style="width: 415px" v-model="form.activityRule" />-->
            <!--            </el-form-item>-->
            <MarketingDialogConfig
              ref="marketingConfig"
              v-if="channelShow"
              v-model="marketingConfig"
            />
          </el-col>

          <el-col :span="12" class="padding-left-10">
            <p class="title">
              <span class="margin-left-10" style="vertical-align: middle">优惠条件</span>
            </p>
            <el-form-item label="优惠条件" prop="tiaoJian">
              <el-radio-group v-model="form.tiaoJian">
                <el-radio :label="1">
                  <span class="margin-left-5 margin-right-10">金额</span>
                  <span>满**元可用</span>
                </el-radio>
                <el-radio :label="2">
                  <span class="margin-left-5 margin-right-10">人数</span>
                  <span>满**人可用</span>
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="优惠内容" prop="youHuiNeiRong">
              <el-radio-group v-model="form.youHuiNeiRong">
                <el-radio :label="1"> 立减金额 </el-radio>
                <el-radio :label="2"> 折扣 </el-radio>
              </el-radio-group>
            </el-form-item>
            <div>
              <el-row v-for="(item, index) in conditionList" :key="item.uuid">
                <el-col :span="22">
                  <div class="flex-top padding-10 color-bg-f6 border-radius-10">
                    <span class="color-main margin-top-5">层级{{ index + 1 }}：</span>
                    <div class="margin-left-10 flex-1">
                      <div class="flex-start">
                        <span class="font-20 font-weight color-redFont margin-right-5">*</span>
                        <template v-if="form.tiaoJian === 1">
                          优惠门槛：满<el-input
                            size="mini"
                            style="width: 60px; margin: 0 5px"
                            v-model.number="item.topMoney"
                            :min="1"
                          />元
                        </template>
                        <template v-if="form.tiaoJian === 2">
                          优惠门槛：满<el-input
                            size="mini"
                            style="width: 60px; margin: 0 5px"
                            v-model.number="item.topPeople"
                            :min="1"
                          />人
                        </template>
                      </div>
                      <div>
                        <div class="flex-center margin-top-20">
                          <span class="font-20 font-weight color-redFont margin-right-5">*</span>
                          <span>优惠内容：</span>
                          <div class="flex-1" v-if="form.youHuiNeiRong === 1">
                            减<el-input
                              size="mini"
                              style="width: 60px; margin: 0 5px"
                              v-model.number="item.liJianMoney"
                              :min="1"
                            />元
                          </div>
                          <div class="flex-1" v-if="form.youHuiNeiRong === 2">
                            打<el-input
                              size="mini"
                              style="width: 60px; margin: 0 5px"
                              v-model="item.zheKou"
                            />折，最高优惠<el-input
                              size="mini"
                              style="width: 60px; margin: 0 5px"
                              v-model="item.maxYouHuiMoney"
                              :min="1"
                            />元
                          </div>
                        </div>
                        <p
                          v-if="form.youHuiNeiRong === 2"
                          class="font-12 color-redFont margin-y-0 margin-left-2 margin-top-3"
                          >折扣区间：1-10，小数点保留1位</p
                        >
                      </div>
                    </div>
                  </div>
                </el-col>
                <el-col :span="2">
                  <div class="flex-center flex-1">
                    <template v-if="index === 0">
                      <el-tooltip class="item" effect="dark" content="新增优惠段" placement="top">
                        <el-button
                          size="mini"
                          circle
                          type="primary"
                          icon="el-icon-plus"
                          @click="addContent"
                        />
                      </el-tooltip>
                    </template>
                    <template v-else>
                      <el-tooltip class="item" effect="dark" content="删除优惠" placement="top">
                        <el-button
                          @click="remove(index)"
                          size="mini"
                          type="danger"
                          circle
                          icon="el-icon-delete"
                        />
                      </el-tooltip>
                    </template>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
        <el-form-item label-width="90px">
          <div class="text-right">
            <el-popconfirm @confirm="onClear('form', 'show')" title="确定取消吗？">
              <el-button slot="reference" type="danger" size="mini">取消</el-button>
            </el-popconfirm>
            <el-button
              class="margin-left-20"
              type="primary"
              size="mini"
              :loading="loading"
              @click="onSubmit('form')"
              >保存</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      top="50px"
      title="使用说明"
      :visible.sync="visible"
      width="500px"
      @close="visible = false"
    >
      <div class="font-12 color-333">
        <div style="white-space: pre-line; line-height: 30px">
          {{ form.describe.replace(/^\s*/, '') }}
        </div>
        <p> 活动路线：{{ lineStr }} </p>
      </div>
    </el-dialog>
    <select-merchant ref="merchant" @submit="getMerchantList" />
  </div>
</template>

<script>
  import SelectMerchant from '@/components/select-merchant/select-merchant'
  import {
    getAcDetail,
    addReduce,
    editReduce,
    getLineByMerchant,
    getChannelManageList
  } from '@/api'
  import { getAllLineList } from '@/api/public'

  import { uuidv5 } from '@/util/util'
  import { pick } from 'lodash-es'
  import dayjs from 'dayjs'
  import MarketingDialogConfig from './MarketingDialogConfig.vue'
  const condition = {
    liJianMoney: 0,
    maxYouHuiMoney: 0,
    sort: 0,
    topMoney: 0,
    topPeople: 0,
    zheKou: 0,
    uuid: uuidv5()
  }
  const money = /^[1-9]\d*$/
  const intNumber = /[^0]\d*/
  export default {
    components: { SelectMerchant, MarketingDialogConfig },
    name: 'modify',
    data() {
      return {
        show: false,
        merchantList: [],
        lineList: [],
        allLines: false,
        form: {
          name: '',
          merchantIds: '',
          merchantNames: '',
          lineIds: '',
          lineNames: '',
          huoDongCiShu: '',
          huoDongZongJinE: '',
          youHuiNeiRong: 1,
          withNewUser: 0,
          withCoupon: 1,
          shiFouChongFu: 1,
          buPiaoShiFouKeYong: 0,
          tiaoJian: 1,
          shiFouSuoYouXianLu: 0,
          describe: ''
        },
        rules: {
          name: [
            { required: true, message: '请输入活动名称', trigger: 'change' },
            { max: 10, message: '长度不超过10个字', trigger: 'change' }
          ],
          // merchantIds: [{ required: true, message: '请选择隶属公司', trigger: 'change' }],
          // lineIds: [
          //   { type: 'array', required: true, message: '请选择可用线路', trigger: 'change' }
          // ],
          time: [{ required: true, message: '请选择活动时间', trigger: 'change' }],
          huoDongCiShu: [
            { required: true, message: '请输入次数', trigger: 'change' },
            { type: 'number', message: '请输入数字', trigger: 'change' },
            {
              pattern: /(^[1-9]\d*$)/,
              required: true,
              message: '请输入正确的金额',
              trigger: 'change'
            }
          ],
          huoDongZongJinE: [
            { required: true, message: '请输入预算金额', trigger: 'change' },
            {
              pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
              required: true,
              message: '请输入正确的金额',
              trigger: 'change'
            }
          ],
          tiaoJian: [{ required: true, message: '请选择优惠条件', trigger: 'change' }],
          youHuiNeiRong: [{ required: true, message: '请选择优惠内容', trigger: 'change' }],
          describe: [{ required: true, message: '请输入规则', trigger: 'change' }],
          channelIdList: [{ required: true, message: '请选择关联渠道', trigger: 'blur' }],
          activityRule: [{ required: true, message: '请输入活动规则', trigger: 'change' }]
        },
        conditionList: [{ ...condition }],
        isEdit: false,
        visible: false,
        loading: false,
        detailLoading: false,
        now: {},
        pickerOptions: {
          disabledDate: (current) => {
            return dayjs().isAfter(dayjs(current), 'd')
          }
        },
        channelOptions: [],
        marketingConfig: {
          mainPicture: '',
          // backgroundPicture: '',
          // buttonColor: '',
          activityRule: ''
        }
      }
    },
    computed: {
      channelShow() {
        return this.form.enableChannelCode === 1
      },
      lineStr() {
        // const { lineList, form } = this
        // const { shiFouSuoYouXianLu, lineIds, describe } = form
        // if ((!lineIds.length || !describe) && !shiFouSuoYouXianLu) {
        //   return ''
        // }
        // if (shiFouSuoYouXianLu) {
        //   return lineList.reduce(
        //     (prev, cur) => (prev ? prev + ',' + cur.lineName : prev + cur.lineName),
        //     ''
        //   )
        // }
        // return lineList
        //   .filter((item) => lineIds.includes(item.id))
        //   .reduce((prev, cur) => (prev ? prev + ',' + cur.lineName : prev + cur.lineName), '')

        if (this.form.shiFouSuoYouXianLu === 1) {
          return this.lineList.reduce(
            (prev, cur) => (prev ? prev + ',' + cur.lineName : prev + cur.lineName),
            ''
          )
        }
        const lineArr = []
        this.merchantList.forEach((item) => {
          if (Array.isArray(item.line) && item.line.length > 0) {
            lineArr.push(...item.line)
          }
        })
        return lineArr
          .filter((item) => item.check === '1')
          .reduce((prev, cur) => (prev ? prev + ',' + cur.lineName : prev + cur.lineName), '')
      }
    },
    mounted() {
      this.queryAllLineList()
      if (!this.form.id) {
        this.$set(this.form, 'enableChannelCode', 0)
      }
    },
    methods: {
      async getChannelManageList() {
        const res = await getChannelManageList()
        if (res.code === 0) {
          this.channelOptions = res.data
        }
      },

      handleMerchant() {
        this.$nextTick(() => {
          this.$refs.merchant.init()
        })
      },
      getMerchantList(merchantLists) {
        this.merchantList = Array.isArray(merchantLists) ? merchantLists : []
        this.form.shiFouSuoYouXianLu = 0
      },
      removeMerchan(index) {
        this.merchantList.splice(index, 1)
      },
      async queryAllLineList() {
        const { code, data } = await getAllLineList()
        if (code !== 0 || !Array.isArray(data)) {
          return
        }
        this.lineList = data.filter((item) => !item.disabled)
      },
      init() {
        this.show = true
        this.isEdit = false
        this.now = {}
        this.conditionList = []
        this.conditionList.push({ ...condition })
        this.merchantList = []
        this.getChannelManageList()
        this.$nextTick(() => {
          this.$refs.form && this.$refs.form.clearValidate()
        })
      },
      async edit(item) {
        this.isEdit = true
        this.show = true
        this.detailLoading = true
        await this.getChannelManageList()
        // const mIds = item.merchantIds.split(',').filter((item) => item)
        // await this.getLineList(mIds[0])
        const { code, data } = await getAcDetail({
          no: item.activityLiJianNo
        })
        this.detailLoading = false
        if (code !== 0) {
          return
        }
        this.now = data
        const {
          // merchantIds = '',
          // lineIds = '',
          activityLiJianItemVoList = [],
          startTime,
          endTime,
          activityRule,
          channelList,
          enableChannelCode
        } = data

        if (channelList && channelList.length > 0) {
          const list = []
          channelList.forEach((item) => {
            list.push(item.id)
          })
          this.$set(this.form, 'channelIdList', list)
        }
        // const mIds = merchantIds.split(',').filter((item) => item)
        // const lIds = lineIds.split(',').filter((item) => item)
        this.form = {
          activityRule,
          enableChannelCode,
          ...this.form,
          ...pick(data, Object.keys(this.form)),
          ...{
            // merchantIds: mIds[0],
            // lineIds: lIds,
            time: [
              startTime ? dayjs(startTime).format('YYYY-MM-DD HH:mm:ss') : '',
              startTime ? dayjs(endTime).format('YYYY-MM-DD HH:mm:ss') : ''
            ]
          }
        }
        this.marketingConfig = {
          activityRule,
          ...this.marketingConfig,
          ...pick(data, Object.keys(this.marketingConfig))
        }
        this.conditionList = activityLiJianItemVoList.map((item) => ({ ...item, uuid: uuidv5() }))
      },
      showRule() {
        this.visible = true
      },
      onAllChange(e) {
        this.form.shiFouSuoYouXianLu = e
        // if (e) {
        //   this.form.lineIds = ['全部']
        // } else {
        //   this.form.lineIds = []
        // }
        this.merchantList = []
      },
      remove(index) {
        this.conditionList.splice(index, 1)
      },
      addContent() {
        this.conditionList.push({ ...condition })
      },
      onChange(e) {
        this.form.lineIds = []
        this.getLineList(e.value)
      },
      getLineList(merchantId) {
        return new Promise((resolve) => {
          getLineByMerchant({ merchantId }).then((resp) => {
            this.lineList = resp.data
            resolve(resp.data)
          })
        })
      },
      closeDialog() {
        this.show = false
      },
      onClear(formName) {
        if (this.$refs[formName]) {
          this.$refs[formName].resetFields()
        }
        this.show = false
        this.conditionList = []
        this.now = {}
        this.form = {
          name: '',
          merchantIds: '',
          merchantNames: '',
          lineIds: '',
          lineNames: '',
          huoDongCiShu: '',
          huoDongZongJinE: '',
          youHuiNeiRong: 1,
          withNewUser: 0,
          withCoupon: 1,
          shiFouChongFu: 1,
          buPiaoShiFouKeYong: 0,
          tiaoJian: 1,
          shiFouSuoYouXianLu: 0,
          describe: ''
        }
      },
      genTypeList(con, type) {
        const reduceFields = {
          topMoney: {
            field: 'topMoney',
            message: '请输入优惠门槛：到达金额',
            type: 'money'
          },
          liJianMoney: {
            field: 'liJianMoney',
            message: '请输入优惠内容：满减金额',
            type: 'money'
          }
        }
        const reduceFields1 = {
          topMoney: {
            field: 'topMoney',
            message: '请输入优惠门槛：到达金额',
            type: 'money'
          },
          zheKou: {
            field: 'zheKou',
            message: '请输入优惠内容：折扣',
            type: 'percent'
          },
          maxYouHuiMoney: {
            field: 'maxYouHuiMoney',
            message: '请输入优惠内容：最高优惠',
            type: 'money'
          }
        }
        const discountFields = {
          topPeople: {
            field: 'topPeople',
            message: '请输入优惠门槛：到达人数',
            type: 'int'
          },
          liJianMoney: {
            field: 'liJianMoney',
            message: '请输入优惠内容：满减金额',
            type: 'money'
          }
        }
        const discountFields1 = {
          topPeople: {
            field: 'topPeople',
            message: '请输入优惠门槛：到达人数',
            type: 'int'
          },
          zheKou: {
            field: 'zheKou',
            message: '请输入优惠内容：折扣',
            type: 'percent'
          },
          maxYouHuiMoney: {
            field: 'maxYouHuiMoney',
            message: '请输入优惠内容：最高优惠',
            type: 'money'
          }
        }
        const { conditionList } = this
        let reduceList = []
        let stop = false
        if (con === 1) {
          if (type === 1) {
            reduceList = conditionList.map((item, index) => ({
              ...pick(item, Object.keys(reduceFields)),
              sort: item.sort || index + 1
            }))
            reduceList.forEach((item) => {
              for (const [k, v] of Object.entries(item)) {
                const it = reduceFields[k]
                if (it && !v) {
                  this.$message.error(it.message)
                  stop = true
                  break
                }
                if (it && it.type === 'money' && !money.test(v)) {
                  this.$message.error('请输入正确的满减金额')
                  stop = true
                  break
                }
                if (it && it.type === 'int' && !intNumber.test(v)) {
                  this.$message.error('请输入正确的人数')
                  stop = true
                  break
                }
              }
            })
          } else {
            reduceList = conditionList.map((item, index) => ({
              ...pick(item, Object.keys(reduceFields1)),
              sort: item.sort || index + 1
            }))
            reduceList.forEach((item) => {
              for (const [k, v] of Object.entries(item)) {
                const it = reduceFields1[k]
                if (it && !v) {
                  this.$message.error(it.message)
                  stop = true
                  break
                }
                if (it && it.type === 'money' && !money.test(v)) {
                  this.$message.error('请输入正确的满减金额')
                  stop = true
                  break
                }
                if (it && it.type === 'int' && !intNumber.test(v)) {
                  this.$message.error('请输入正确的人数')
                  stop = true
                  break
                }
              }
            })
          }
        } else {
          if (type === 1) {
            reduceList = conditionList.map((item, index) => ({
              ...pick(item, Object.keys(discountFields)),
              sort: item.sort || index + 1
            }))
            reduceList.forEach((item) => {
              for (const [k, v] of Object.entries(item)) {
                const it = discountFields[k]
                if (it && !v) {
                  this.$message.error(it.message)
                  stop = true
                  break
                }
                if (it && it.type === 'money' && !money.test(v)) {
                  this.$message.error('请输入正确的满减金额')
                  stop = true
                  break
                }
                if (it && it.type === 'int' && !intNumber.test(v)) {
                  this.$message.error('请输入正确的人数')
                  stop = true
                  break
                }
              }
            })
          } else {
            reduceList = conditionList.map((item, index) => ({
              ...pick(item, Object.keys(discountFields1)),
              sort: item.sort || index + 1
            }))
            reduceList.forEach((item) => {
              for (const [k, v] of Object.entries(item)) {
                const it = discountFields1[k]
                if (it && !v) {
                  this.$message.error(it.message)
                  stop = true
                  break
                }
                if (it && it.type === 'money' && !money.test(v)) {
                  this.$message.error('请输入正确的满减金额')
                  stop = true
                  break
                }
                if (it && it.type === 'int' && !intNumber.test(v)) {
                  this.$message.error('请输入正确的人数')
                  stop = true
                  break
                }
              }
            })
          }
        }
        return {
          stop,
          reduceList
        }
      },
      onSubmit(formName) {
        this.$refs[formName].validate(async (valid) => {
          if (valid) {
            const { form, now, isEdit } = this

            if (!this.channelShow) {
              this.form.channelIdList = []
              this.form.activityRule = ''
            }

            const { time, youHuiNeiRong, tiaoJian, shiFouSuoYouXianLu, ...rest } = form
            const postData = {
              ...rest,
              tiaoJian,
              youHuiNeiRong,
              startTime: time[0],
              endTime: time[1],
              shiFouSuoYouXianLu
            }
            if (shiFouSuoYouXianLu !== 1 && !this.isEdit) {
              // postData.lineIds = lineIds.join(',')
              // 校验供应商
              const merchantArr = []
              const lineArr = []
              this.merchantList.forEach((item) => {
                merchantArr.push(item.merchantId)
                const arr = Array.isArray(item.line) ? item.line : []
                arr.forEach((obj) => {
                  if (obj.check === '1') {
                    lineArr.push(obj.lineId)
                  }
                })
              })
              if (merchantArr.length === 0) {
                this.$message.error('请选择隶属公司')
                return
              }
              if (lineArr.length === 0) {
                this.$message.error('请选择线路')
                return
              }
              postData.merchantIds = merchantArr.join(',')
              postData.lineIds = lineArr.join(',')
            }
            const { stop, reduceList } = this.genTypeList(tiaoJian, youHuiNeiRong)
            if (stop) {
              return
            }
            postData.activityLiJianItemDtos = reduceList

            const submit = async () => {
              this.loading = true
              if (isEdit) {
                postData.activityLiJianNo = now.activityLiJianNo
                const { code } = await editReduce(postData)
                this.loading = false
                if (code === 0) {
                  this.$message.success('保存成功')
                  this.$emit('onSuccess', 'edit')
                  this.onClear(formName, 'show')
                }
                return
              }
              const { code } = await addReduce(postData)
              this.loading = false
              if (code === 0) {
                this.$message.success('保存成功')
                this.$emit('onSuccess', 'add')
                this.onClear(formName, 'show')
              }
            }

            // 打开关联渠道码
            if (this.channelShow) {
              this.$refs.marketingConfig.validateForm().then((res) => {
                Object.assign(postData, res)
                submit()
              })
            } else {
              await submit()
            }
          }
        })
      }
    }
  }
</script>
<style scoped lang="scss">
  .channel-dialog {
    width: 270px;
    padding: 5px 10px;
    position: absolute;
    bottom: -20px;
    left: 0;
    background: #fff;
    box-sizing: border-box;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    .item {
      height: auto;
      line-height: 30px;
      display: flex;

      .tit {
        font-weight: bold;
        width: 60px;
        white-space: nowrap;
        text-align: right;
      }
      .txt {
        width: 190px;
      }
    }
  }
  .title {
    margin: 0 0 10px;
    font-size: 16px;
    font-weight: 700;

    &:before {
      content: '';
      width: 4px;
      height: 16px;
      display: inline-block;
      background: #1089ff;
      vertical-align: middle;
    }
  }

  .box-card {
    box-sizing: border-box;
    width: 100%;
    max-height: 250px;
    padding: 8px;
    border-radius: 4px;
    border: 1px solid #ebeef5;
    overflow-x: hidden;
    overflow-y: auto;
  }
</style>
